import React from 'react';
import { Container, Section } from 'react-bulma-components';
import { useNavigate } from 'react-router';
import { usePageTitle } from '../../hooks/usePageTitle';
import styles from './ShippingAndDelivery.module.scss';
import SupportEmailLink from '../../components/SupportEmailLink/SupportEmailLink';
import DiscordInviteButton from '../../components/DiscordInviteButton/DiscordInviteButton';

const ShippingAndDelivery: React.FC = () => {
  const navigate = useNavigate();

  usePageTitle({
    title: 'Shipping and Delivery Policy | OnePlay',
    description: 'Learn about OnePlay\'s digital product delivery process, instant activation timelines, and customer support for any delivery concerns.'
  });

  const handleActivationGuideClick = () => {
    navigate('/activation-guides');
  };

  return (
    <Section className={styles.shippingDeliverySection}>
      <Container>
        <div className={styles.content}>
          <button 
            className={styles.activationGuideButton}
            onClick={handleActivationGuideClick}
          >
            <span className={styles.activationGuideIcon}>📚</span>
            <span className={styles.activationGuideText}>Go to Activation Guide</span>
            <span className={styles.activationGuideArrow}>→</span>
          </button>
          <h1 className={styles.title}>Shipping and Delivery Policy</h1>
          
          <div className={styles.description}>
            Learn about OnePlay's digital product delivery process, instant activation timelines, and customer support for any delivery concerns.
          </div>

          <div className={styles.section}>
            <h2 className={styles.sectionTitle}>Delivery Timeline</h2>
            <p className={styles.sectionContent}>
              Delivery post successful payment up to 24 hours. Processing and delivering orders could sometimes take 24-48 hours.
            </p>
          </div>

          <div className={styles.section}>
            <h2 className={styles.sectionTitle}>Digital Products</h2>
            <p className={styles.sectionContent}>
              There is no physical shipping involved. All products on OnePlay Store are digital and delivered instantly via email after successful payment.
            </p>
          </div>

          <div className={styles.section}>
            <h2 className={styles.sectionTitle}>Email Notifications</h2>
            <p className={styles.sectionContent}>
              Users will be notified via email once their order is processed and the digital product is ready for activation.
            </p>
          </div>

          <div className={styles.section}>
            <h2 className={styles.sectionTitle}>Customer Support</h2>
            <p className={styles.sectionContent}>
              Users can contact <SupportEmailLink /> or Discord team for delivery-related concerns.
            </p>
            <div style={{ marginTop: '1rem' }}>
              <DiscordInviteButton />
            </div>
          </div>

          <div className={styles.section}>
            <h2 className={styles.sectionTitle}>Steps to Get Your Code/Key</h2>
            <p className={styles.sectionContent}>
              For detailed instructions on how to get your activation key, Steam wallet code, or Valorant Points code, please visit:{' '}
              <a 
                href="https://forums.oneplay.in/t/how-to-get-your-activation-key-steam-wallet-code-valorant-points-code/83" 
                target="_blank" 
                rel="noopener noreferrer"
                className={styles.externalLink}
              >
                Steps to get your code/key on OnePlay Store
              </a>
            </p>
          </div>

          <div className={styles.thankYou}>
            Thank you for shopping with OnePlay!
          </div>
        </div>
      </Container>
    </Section>
  );
};

export default ShippingAndDelivery;

